import { titleize, capitalize } from './StringUtils'
import { flatten } from './CollectionUtils'

export function decodeJSONApiError(errorResponse){
  if(errorResponse && errorResponse.body && errorResponse.body.errors){
    const firstError = {...errorResponse.body.errors[0]}
    firstError.additionalErrors = errorResponse.body.errors
    return firstError
  }
  return errorResponse
}

export function errorStringsFromError(error){
  return rawErrorStringsFromJSONApiError(error)
}

export function rawErrorStringsFromJSONApiError(error) {
  if(typeof error === 'string'){
    return [error]
  }
  if(Array.isArray(error)){
    return flatten(error.map(rawErrorStringsFromJSONApiError))
  }
  const { meta={}, title='', message='' } = error || {}
  return [`${title}${(title && message && title !== message) ? ': ' : ''}${title !== message ? message : ''}`].concat(
    Object.entries(meta ?? {}).map(([key, values]) => `${titleize(key)}: ${capitalize(values.join(', '))}`)
  ).filter(x => !!x)
}

export function downloadContent(content, filename, type='application/text') {
  let blob = new Blob([content], {type})
  let link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click()
}

// Older version of rawErrorStringsFromJSONApiError?
export function parseAttributeErrorsArray(errors){
  const errorMap = {}
  errors.forEach(({detail, source: { pointer }}) => {
    const attributes = pointer.split(/\//)
    const attribute  = attributes[attributes.length - 1]
    errorMap[titleize(attribute)] = errorMap[titleize(attribute)] || []
    errorMap[titleize(attribute)].push(detail)
  })
  return errorMap
}

// Older version of errorStringsFromError?
export function generateAttributesErrorsString(errors){
  return Object.entries(parseAttributeErrorsArray(errors)).map(([key, values]) => `${key}: ${values.join(', ')}`).join('. ')
}